module.exports = __webpack_public_path__ + "static/img/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-3.99a6fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promo/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-3.png
// module id = jG5w
// module chunks = 0